import { useAuth } from '@hooks';
import { PartnerCompaniesContractStatusEnum } from '@constants';
import { UserType } from '@contexts';

import { StyledAlert, StyledTypography } from './styles';

export function CanceledPartnerCompanyAlert() {
  const { user, selectedPartnerCompany, currentCompany } = useAuth();

  const isPartnerCompanyCanceled =
    selectedPartnerCompany?.partnerCompanyStatus ===
    PartnerCompaniesContractStatusEnum.CANCELED;

  if (!isPartnerCompanyCanceled) {
    return null;
  }

  const isBackoffice = user?.companyType === UserType.Backoffice;
  const { cancellationDate } = currentCompany ?? {};

  return (
    <StyledAlert severity="info" isBackoffice={isBackoffice}>
      <StyledTypography isBackoffice={isBackoffice} variant="text">
        Este contrato foi cancelado
        {cancellationDate && (
          <StyledTypography isBackoffice={isBackoffice} variant="text">
            {' '}
            em{' '}
            <StyledTypography
              isBackoffice={isBackoffice}
              variant="text"
              fontWeight={700}
            >
              {cancellationDate}
            </StyledTypography>
          </StyledTypography>
        )}
        . Funcionalidades importantes seguem disponíveis para você
      </StyledTypography>
    </StyledAlert>
  );
}
